import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';

const selectAccessibilityState = (state: RootState) => state.accessibility;

const selectAccessibilityFontSize = createSelector(
  selectAccessibilityState,
  (accessibility) => accessibility.fontSize
);

const selectIsDarkMode = createSelector(
  selectAccessibilityState,
  (accessibility) => accessibility.isDarkMode
);

export default {
  selectAccessibilityState,
  selectAccessibilityFontSize,
  selectIsDarkMode
};
